<div
  *ngIf="form && definition"
  class="soft-container soft-container-column"
  [ngSwitch]="definition.control"
>
  <label class="soft-label soft-label-top">{{ definition.title }}</label>
  <soft-toggle-switch
    *ngSwitchCase="'switch'"
    [formControl]="form|formControl:definition.name"
    [readonly]="definition.readonly | booleanRule: form.value"
    softFieldValidation
  >
    <span class="soft-label soft-label-right"> {{ definition.label }}</span>
  </soft-toggle-switch>
  <soft-checkbox
    *ngSwitchDefault
    [formControl]="form|formControl:definition.name"
    [readonly]="definition.readonly | booleanRule: form.value"
    softFieldValidation
  >
    <span class="soft-label soft-label-right"> {{ definition.label }}</span>
  </soft-checkbox>
</div>
